import { Component, OnInit } from '@angular/core';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { DashCred } from './../../models/dash';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-patient-list',
  templateUrl: './patient-list.component.html',
  styleUrls: ['./patient-list.component.css']
})
export class PatientListComponent implements OnInit {
  public chkdet: any;
  dcred = new DashCred();
  patientd = [];
  // patientd = new PatientD();
  pat: string;
  patid: any;
  data: any;
  submitted: boolean;

  constructor(private patChkInService: VproService, private patService: VproService, private route: ActivatedRoute) { }

  ngOnInit() {

    this.getCheckedInPats(localStorage.getItem('LogUsr'));
    this.patid = this.route.snapshot.params['patid'];

  }

  // Try to fetch Checked-In Patients

  getCheckedInPats(usereid: string) {

    //    this.dcred.usereid = localStorage.getItem('LogUsr');
    try {
      this.patChkInService.getCheckedInPats().subscribe(res => {
        this.chkdet = res;
        // this.appointName = res;
      }, error => {
        console.log(error);
      });
    } catch (excep) {
      console.log(excep);
    }
  }

  myFunction() {

    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("myTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td");
      if (td && td.length > 0) {
        txtValue = td[0].textContent || td[0].innerText;
        if (td[2].innerHTML.toUpperCase().indexOf(filter) > -1 || td[3].innerHTML.toUpperCase().indexOf(filter) > -1 || td[4].innerHTML.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  public formatTime(value) {
    let res;
    if (value && typeof value === "string") {
      let keys = value.split(":");
      res = this.getTime(keys[0]) + " : " + keys[1] + " " + this.getFormat(keys[0]);
    }
    return res;
  }

  getTime(time) {
    if (parseInt(time) > 12) {
      time = (parseInt(time) - 12).toString();
    }
    return time;
  }

  getFormat(value) {
    if (parseInt(value) < 12) {
      return 'AM';
    } else {
      return 'PM';
    }
  }
}
